"use strict";
var body = $("body");
$(document).ready(function () {
    const carouselDetects = document.querySelectorAll(".products-carousel");
    carouselDetects.forEach(carousel => {
        const scrollbar = carousel.parentNode.querySelector('.swiper-scrollbar');
        const productsCarousel = new Swiper(carousel, {
            slidesPerView: "auto",
            spaceBetween: 160,
            freeMode: !0,
            scrollbar: {el: scrollbar, hide: !0},
            breakpoints: {2: {slidesPerView: 2, spaceBetween: 0}, 768: {slidesPerView: "auto", spaceBetween: 160}}
        })
    });


    var productPageDetect = document.querySelector(".product-page_media.swiper");
    if (productPageDetect) var productPageCarousel = new Swiper(".product-page_media.swiper", {
        direction: "vertical",
        spaceBetween: 60,
        freeMode: !0,
        loop: !0,
        autoHeight: !0,
        mousewheel: {invert: !1, releaseOnEdges: !0, sensitivity: .3, thresholdDelta: .3},
        pagination: {el: ".swiper-pagination", clickable: !0, dynamicBullets: !0},
        breakpoints: {
            320: {spaceBetween: 30},
            991: {spaceBetween: 30, direction: "vertical"},
            1020: {spaceBetween: 0, direction: "vertical"},
            1200: {spaceBetween: 60, direction: "vertical"}
        }
    });
    var carouselDetectCat = document.querySelector(".catalog-carousel");
    if (carouselDetectCat) var productsCarouselCat = new Swiper(".catalog-carousel", {
        slidesPerView: "auto",
        spaceBetween: 26,
        freeMode: !0,
        breakpoints: {2: {slidesPerView: "auto", spaceBetween: 17}, 768: {slidesPerView: "auto", spaceBetween: 26}}
    });
    var carouselNews = document.querySelector(".news-carousel");
    if (carouselNews) var carouselNewsItem = new Swiper(".news-carousel", {
        slidesPerView: 3,
        spaceBetween: 30,
        breakpoints: {
            320: {slidesPerView: 1.05, spaceBetween: 10},
            768: {slidesPerView: 1.4, spaceBetween: 10},
            1020: {slidesPerView: 3, spaceBetween: 29},
            1600: {slidesPerView: 4, spaceBetween: 60}
        }
    });
    if ($(window).width() < 1199) var productsCarousel = new Swiper(".product-layout__pct", {
        slidesPerView: 1,
        spaceBetween: 0,
        nested: !0,
        pagination: {el: ".swiper-pagination", clickable: !0}
    });
    var priceRange = $("#price-range");
    priceRange.slider({
        range: !0, min: 0, max: 1e3, values: [100, 900], create: function () {
            var handles = priceRange.find(".ui-slider-handle");
            $(handles[0]).append('<div class="ui-slider-tip">' + priceRange.slider("values", 0) + "</div>"), $(handles[1]).append('<div class="ui-slider-tip">' + priceRange.slider("values", 1) + "</div>")
        }, slide: function (event, ui) {
            var handles = priceRange.find(".ui-slider-handle");
            $(handles[0]).find(".ui-slider-tip").text(ui.values[0]), $(handles[1]).find(".ui-slider-tip").text(ui.values[1])
        }
    });
    var demo = document.querySelector(".side-panel");
    $("select").selectric({
        disableOnMobile: !1,
        nativeOnMobile: !1
    }), deviceCheck(), getCookie("cookies"), $("[data-fancybox]").fancybox({touch: !1})
}), $(window).on("resize", function () {
    deviceCheck()
}), $(window).on("scroll", function () {
    $(window).scrollTop() > 0 ? $(".header").addClass("scrolled") : $(".header").removeClass("scrolled")
}), body.on("click", ".header-toggle", function () {
    $(this).hasClass("active") ? $(this).addClass("not-active") : $(this).removeClass("not-active"), $(this).toggleClass("active"), $(".header__nav").slideToggle()
}), $(document).on("click", ".filter-item__label", function () {
    $(this).toggleClass("active"), $(this).next().slideToggle(300)
}), body.on("click", ".header__nav--mob .has-children", function (e) {
    e.target.className.includes("sub-menu__title") || ($(this).toggleClass("active"), $(this).find(".sub-menu").slideToggle(300))
}), body.on("click", ".header__nav--mob .sub-menu__title", function (e) {
    $(this).toggleClass("active"), $(this).next().slideToggle(300)
}), body.on("click", ".js-side-panel-close", function (e) {
    $(".side-panel").removeClass("active")
}), body.on("click", ".js-side-panel-open", function (e) {
    $(".side-panel").addClass("active")
}), body.on("mouseover", ".header__dd ul a[data-img]", function (e) {
    $(this).closest(".header__dd").find(".dd-banner").addClass("active").find("img").attr("src", $(this).data("img"))
}), body.on("click", ".header__nav>ul>li.has-child", function (e) {
    if ($(window).width() <= 1199) {

        if ($(e.target).closest(".header__dd").length) return;

        e.preventDefault();
        $(this).siblings().slideToggle();
        $(this).closest('ul').siblings('ul').slideToggle();
        $(this).toggleClass("active").find(".header__dd").slideToggle();
    }
});

function cookiesClose() {
    $(".cookies, .overlay").fadeOut()
}

function cookiesOpen() {
    $(".cookies, .overlay").fadeIn()
}

function setCookie(key, value) {
    var currentDate = new Date;
    currentDate.setDate(currentDate.getDate() + 1);
    var expires = "expires=" + currentDate.toUTCString();
    document.cookie = key + "=" + value + "; " + expires
}

function getCookie(key) {
    for (var name = key + "=", decodedCookie = decodeURIComponent(document.cookie), cookieArray = decodedCookie.split(";"), i = 0; i < cookieArray.length; i++) {
        for (var cookie = cookieArray[i]; cookie.charAt(0) === " ";) cookie = cookie.substring(1);
        if (cookie.indexOf(name) === 0) return cookie.substring(name.length, cookie.length)
    }
    return ""
}

function deviceCheck() {
    $(window).width() < 1200 ? body.addClass("touch") : body.removeClass("touch")
}

if (body.on("click", "[data-filter]", function () {
    $(this).toggleClass("active");
    var activeFilters = $("[data-filter].active");
    activeFilters.length === 0 ? ($("[data-key]").hide(), $("[data-key]").show()) : ($("[data-key]").hide(), $("[data-key].hidden").hide(), activeFilters.each(function () {
        var filterValue = $(this).data("filter");
        filterValue === "all" && ($("[data-key]").show(), activeFilters.removeClass("active")), $('[data-key="' + filterValue + '"]').show()
    }))
}), document.querySelector(".popup_bag .popup__body")) var ps = new PerfectScrollbar(".popup_bag .popup__body");
if (document.querySelector(".popup_size .popup__body")) var ps2 = new PerfectScrollbar(".popup_size .popup__body");
if (document.querySelector(".popup_shipping .popup__body")) var ps3 = new PerfectScrollbar(".popup_shipping .popup__body");
if (document.querySelector(".popup_search .popup__body")) var ps4 = new PerfectScrollbar(".popup_search .popup__body");

function openTab(evt, tabName) {
    var i, tabcontent, tablinks;
    for (tabcontent = document.getElementsByClassName("tab"), tablinks = document.getElementsByClassName("tab-button"), i = 0; i < tabcontent.length; i++) tabcontent[i].classList.remove("active"), tablinks[i].classList.remove("active");
    document.getElementById(tabName).classList.add("active"), evt.currentTarget.classList.add("active")
}

function openPopup(popupId, i) {
    if (popupId == "popup_images") {
        console.log("i", i);
        const popupImagesWrapImgs = document.querySelector("#popup_images");
        if (!popupImagesWrapImgs) return;
        const slides = popupImagesWrapImgs.querySelectorAll(".swiper-wrapper .swiper-slide");
        if (i < 0 || i >= slides.length) return;
        slides[i].scrollIntoView({behavior: "smooth", block: "start"}), window.scrollBy(0, -30)
    }
    var popup = document.getElementById(popupId), popupUser2 = document.querySelectorAll(".popup");
    popupUser2.forEach(function (popup2) {
        popup2.classList.remove("open")
    }), popup.classList.contains("open") ? (popup.classList.remove("open"), document.querySelector("body").classList.remove("disable-scroll")) : popupId == "popup_images" ? (setTimeout(function () {
        popup.classList.add("open")
    }, 500), setTimeout(function () {
        document.querySelector("body").classList.add("disable-scroll")
    }, 1e3)) : (popup.classList.add("open"), document.querySelector("body").classList.add("disable-scroll"))
}

var popupUser = document.querySelectorAll(".popup"), popupClose = document.querySelectorAll(".popup__close");
popupClose && popupClose.forEach(function (element) {
    element.addEventListener("click", function (event) {
        popupUser.forEach(function (popup) {
            popup.classList.remove("open")
        }), document.querySelector("body").classList.remove("disable-scroll")
    })
});
//# sourceMappingURL=/cdn/shop/t/97/assets/app.js.map?v=94621802286031421041741681218


document.addEventListener("DOMContentLoaded", () => {
    const grid = document.querySelector("[data-product-grid]");
    let observer;
    let autoLoad = false;

    function initLoadMore(wrapper) {
        const button = wrapper?.querySelector(".catalog-load-more");
        const pagination = wrapper?.querySelector(".catalog-pagination");
        if (!button) return;

        button.replaceWith(button.cloneNode(true));
        const newButton = wrapper.querySelector(".catalog-load-more");

        async function loadMore() {
            const url = newButton.dataset.nextUrl;
            const sectionId = newButton.dataset.sectionId;

            newButton.classList.add("loading");

            const res = await fetch(`${url}&section_id=${sectionId}`);
            const text = await res.text();
            const html = new DOMParser().parseFromString(text, "text/html");

            const newProducts = html.querySelector("[data-product-grid]")?.children || [];
            [...newProducts].forEach((el) => grid.appendChild(el));

            const fetchWrapper = html.querySelector("[data-product-pagination-wrapper]");
            if (fetchWrapper) wrapper.innerHTML = fetchWrapper.innerHTML;
            else {
                wrapper.remove();
                if (observer) observer.disconnect();
                return;
            }

            const nextButton = wrapper.querySelector(".catalog-load-more");
            if (nextButton) newButton.dataset.nextUrl = nextButton.dataset.nextUrl;
            else newButton.remove();

            newButton.classList.remove("loading");

            initLoadMore(wrapper);
        }

        newButton.addEventListener("click", () => {
            if (!autoLoad) {
                autoLoad = true;
                setTimeout(() => {
                    if (pagination) pagination.style.display = "none";
                }, 700);
            }
            loadMore();
        });

        if (observer) observer.disconnect();
        observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && autoLoad) loadMore();
                });
            },
            { rootMargin: "50%" }
        );
        observer.observe(newButton);
    }

    const initialWrapper = document.querySelector("[data-product-pagination-wrapper]");
    if (initialWrapper) initLoadMore(initialWrapper);

    document.addEventListener("collection:updated", () => {
        const wrapper = document.querySelector("[data-product-pagination-wrapper]");
        if (wrapper) initLoadMore(wrapper);
    });
});


// sticky add to cart button
(function () {
    const BREAKPOINT = 991;
    let originalBtn = document.querySelector('.btn-add-cart');
    let stickyWrapper = null;

    function createSticky() {
        if (stickyWrapper) return;

        const wrapper = document.createElement('div');
        wrapper.classList.add('sticky-add-cart-wrapper');
        Object.assign(wrapper.style, {
            position: 'fixed',
            bottom: '0',
            left: '0',
            width: '100%',
            background: '#fff',
            zIndex: '9',
            display: 'flex',
            justifyContent: 'center',
            padding: '10px 20px'
        });

        const stickyBtn = originalBtn.cloneNode(true);
        stickyBtn.classList.add('sticky-add-cart');
        Object.assign(stickyBtn.style, {
            padding: '10px 20px'
        });

        wrapper.appendChild(stickyBtn);
        document.body.appendChild(wrapper);

        stickyWrapper = wrapper;

        stickyBtn.addEventListener('click', function (e) {
            e.preventDefault();
            originalBtn = document.querySelector('.btn-add-cart');
            if (originalBtn) {
                originalBtn.click();
                setTimeout(() => {
                    const errorBox = document.querySelector('.error-option');
                    const hasError = errorBox && (errorBox.children.length > 0 || errorBox.textContent.trim().length > 0);
                    if (hasError) {
                        const target = errorBox || originalBtn;
                        target.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                }, 500);
            }
        });
    }

    function removeSticky() {
        if (!stickyWrapper) return;
        stickyWrapper.remove();
        stickyWrapper = null;
    }

    function isOriginalVisible() {
        if (!originalBtn) return false;
        const rect = originalBtn.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function updateSticky() {
        originalBtn = document.querySelector('.btn-add-cart');
        if (!originalBtn || window.innerWidth > BREAKPOINT) {
            removeSticky();
            return;
        }
        createSticky();
        stickyWrapper.style.display = isOriginalVisible() ? 'none' : 'flex';
    }

    const observer = new MutationObserver(() => updateSticky());
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('scroll', updateSticky);
    window.addEventListener('resize', updateSticky);
    updateSticky();
})();


// video autoplay
document.addEventListener("DOMContentLoaded", function () {
    const videos = document.querySelectorAll(".product-page_media_item video");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;

        if (entry.intersectionRatio >= 0.2) {
          if (video.paused) {
            video.play().catch(() => {});
          }
        } else {
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }, {
      threshold: [0, 0.2, 1]
    });

    videos.forEach(video => {
      observer.observe(video);
    });
});